import type { BrowserWindow, MemberDetails } from '@wix/thunderbolt-symbols'
import { memberDetailsMpaSessionStorageKey } from './constants'

export type MemberDetailsMpaCache = {
	read: (expectedMemberId: string | undefined | null) => MemberDetails | null
	write: (memberDetails: MemberDetails) => void
	clear: () => void
	isHardReload: () => boolean
}

export const createMemberDetailsMpaCache = (browserWindow: BrowserWindow): MemberDetailsMpaCache => {
	const isHardReload = (): boolean => {
		const navEntries = browserWindow?.performance?.getEntriesByType?.('navigation') as
			| Array<PerformanceNavigationTiming>
			| undefined
		return navEntries?.[0]?.type === 'reload'
	}

	return {
		isHardReload,
		read: (expectedMemberId) => {
			try {
				// Skip cache on hard reload to emulate current SPA behavior
				if (isHardReload()) {
					return null
				}
				const cached = browserWindow?.sessionStorage?.getItem?.(memberDetailsMpaSessionStorageKey)
				if (!cached) {
					return null
				}
				const parsed = JSON.parse(cached) as MemberDetails
				if (parsed.id && parsed.id === expectedMemberId) {
					return parsed
				}
			} catch {}
			return null
		},
		write: (memberDetails) => {
			try {
				browserWindow?.sessionStorage?.setItem?.(memberDetailsMpaSessionStorageKey, JSON.stringify(memberDetails))
			} catch {}
		},
		clear: () => {
			try {
				browserWindow?.sessionStorage?.removeItem?.(memberDetailsMpaSessionStorageKey)
			} catch {}
		},
	}
}
